'use client';
import { useMemo } from 'react';
import { useSelectedContext } from '../../context';

const useFilterUnselected = <T extends { id: string }>(items: T[]) => {
  const isSelected = useSelectedContext();
  return useMemo(() => items.filter(d => !isSelected(d.id)), [items, isSelected]);
};

export default useFilterUnselected;
